<template>
  <div class="capsule-chart-content">
    <div class="capsule-line-content">
      <div
        class="capsule-line"
        v-for="(item, index) in outW.data"
        :key="item.name"
      >
        <div class="capsule-name">
          {{ item.name }}
        </div>
        <div class="prograss">
          <div class="capsule-line-item">
            <div
              class="capsule-line-label"
              :style="{
                width: setProgress(inW.data[index]),
              }"
            >
              <div class="label-text">{{ inW.data[index].value }}</div>
            </div>
          </div>
          <div class="capsule-line-item">
            <div
              class="capsule-line-label warn"
              :style="{
                width: setProgress(item),
              }"
            >
              <div class="label-text">{{ item.value }}</div>
            </div>
          </div>
          
        </div>

        <!-- <div class="astrict-value">{{ item.min }} - {{ item.max }}</div> -->
      </div>
    </div>

    <div class="tips-content">
      <div class="tips-item">
        <div class="not"></div>
        进水
      </div>
      <div class="tips-item">
        <div class="warn"></div>
        出水达标
      </div>
      
      
      <div class="tips-item">
        <div class="error"></div>
        出水不达标
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["config"],
  data() {
    return {
      list: {
        data: [],
        colors: [],
      },
      inW: {},
      outW: {},
      colors: [],
    };
  },
  watch: {
    config(val) {
      this.init(val);
    },
  },
  created() {
    this.init(this.config);
  },
  methods: {
    init(val) {
      let runActionConfig = JSON.parse(val);
      this.inW = runActionConfig.inW.data;
      this.outW = runActionConfig.outW.data;
      this.colors = this.list.colors;
    },
    setProgress(item) {
      const data = item;
      if (data) {
        let b = (data.value / data.max) * 100;

        return (b < 100 ? b : 100) + "%";
      }
      return "0%";
    },
  },
};
</script>
<style lang="scss" scoped>
.capsule-chart-content {
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 15px 0 15px 10px;
  box-sizing: border-box;
  .tips-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    position: absolute;
    right: 0;
    width: 100px;
    bottom: 0;
    .tips-item {
      display: flex;
      align-items: center;
      margin-right: 15px;
      margin-bottom: 10px ;
    }
    .not,
    .warn,.error {
      width: 10px;
      height: 10px;
      margin-right: 5px;
    }
  }

  .capsule-name {
    width: 60px;
    text-align: right;
    padding-right: 10px;
    box-sizing: border-box;
  }
  .capsule-line-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .capsule-line {
    display: flex;
    align-items: center;
    .prograss {
      width: 65%;
      // margin-bottom: 10px;
    }
    .capsule-line-item {
      height: 10px;
      // border-radius: 50px;
      margin-bottom: 3px;
      position: relative;
      // border: 1px solid rgba($color: #fff, $alpha: 0.2);
      //   box-shadow: 0 0 5px 0px #fff;
      display: flex;
      align-items: center;

      .capsule-line-label {
        position: absolute;
        transition: all 0.4s;
        left: 0;
        top: 0;
        height: 100%;
        // border-radius: 50px;
        background:#159aff;// linear-gradient(to right, #159aff, #159aff);
        width: 80%;
        .label-text {
          padding-left: 10px;
          transform: translate(100%,-1px);
          line-height: 12px;
        }
      }
    }
  }
  .astrict-value {
    margin-left: 25px;
  }
}
.not {
  background:#159aff!important;
}
.warn {
  background:#72e9f5!important;
}
.error{
  background: linear-gradient(to right, #ff7734, #ff7734) !important;
}
</style>